export enum MediaType {
  vod = 'VOD',
  live = 'LIVE',
  catchup = 'CATCHUP',
  recording = 'RECORDING',
  startover = 'STARTOVER',
}

export enum Orientation {
  landscape = 'LANDSCAPE',
  portrait = 'PORTRAIT',
}

export enum ConnectivityType {
  iptv = 'IPTV',
  ott = 'OTT',
}

export enum DeviceStatus {
  unknown = 'UNKNOWN',
  up = 'UP',
  streaming = 'STREAMING',
  standby = 'STANDBY',
}

export enum Connectivity {
  unknown = 'UNKNOWN',
  online = 'ONLINE',
  offline = 'OFFLINE',
}

export enum StbInterface {
  video = 'VIDEO',
  scart = 'SCART',
  hdmi = 'HDMI',
  other = 'OTHER',
}

export enum YesNoOption {
  unknown = 'UNKNOWN',
  yes = 'YES',
  no = 'NO',
}

export enum NetworkType {
  lan = 'LAN',
  wlan = 'WLAN',
  data = 'DATA',
}

export enum PairingStatus {
  connected = 'CONNECTED',
  notconnected = 'NOT_CONNECTED',
  unknown = 'UNKNOWN',
}

export enum Communication {
  unicast = 'UNICAST',
  multicast = 'MULTICAST',
}
